import Alert from "@pathwright/ui/src/components/alert/Alert"
import Card from "@pathwright/ui/src/components/card/Card"
import CardBlock from "@pathwright/ui/src/components/card/CardBlock"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import LoadingCircle from "@pathwright/ui/src/components/loading/LoadingCircle"
import PropTypes from "prop-types"
import { useContextualFeaturePermissionQuery } from "../../api/generated"
import { usePathwrightContext } from "../../pathwright/PathwrightContext"
import FeatureBlockItem from "../block/FeatureBlockItem"
import FeaturePermissionsAuthLoginForm from "../form/FeaturePermissionsAuthLoginForm"
import { featurePermissionsQueryPropTypes } from "../propTypes"

const ManageFeaturesAuthLoginFeature = ({ card, ...variables }) => {
  const { t } = useTranslate()
  const { school } = usePathwrightContext()

  const cfpQuery = useContextualFeaturePermissionQuery({
    variables
  })

  const feature = cfpQuery.data && cfpQuery.data.contextualFeaturePermission

  return (
    <Card card={card} emphasis="secondary">
      {cfpQuery.loading ? (
        <LoadingCircle center />
      ) : cfpQuery.error ? (
        <Alert error={cfpQuery.error} />
      ) : (
        <CardBlock paddingTop={false} paddingBottom={false}>
          <FeatureBlockItem feature={feature} />
          <FeaturePermissionsAuthLoginForm featureKey={feature.feature_key} />
        </CardBlock>
      )}
    </Card>
  )
}

ManageFeaturesAuthLoginFeature.displayName = "ManageFeaturesAuthLoginFeature"

ManageFeaturesAuthLoginFeature.propTypes = {
  // provided by CardStack > CardStackCard
  card: PropTypes.object.isRequired,
  ...featurePermissionsQueryPropTypes
}

export default ManageFeaturesAuthLoginFeature
